/*
  OffCourt — unified site header behaviour.

  The shared ots-header section is used by both layouts. Under the storefront
  layout (homepage, collections) ots-storefront.js already wires the burger,
  the mega menu and the cart button, so this file stands down there and only
  takes over on the layouts that do not load it — product, blog, page, cart,
  search and account.

  Deliberately a header-only build rather than loading ots-storefront.js
  everywhere: that bundle also initialises a PDP gallery, collection filters,
  tabs and accordions, none of which belong on these pages.
*/
(function () {
  'use strict';

  // ots-storefront.js owns the header wherever it is loaded. Binding on top of
  // it would double-fire the cart open and re-request the cart on every click.
  if (document.querySelector('script[src*="ots-storefront.js"]')) return;
  if (window.__ocHeaderUnified) return;
  window.__ocHeaderUnified = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------- desktop mega menu + mobile drawer ---------- */
  function initHeader() {
    var header = $('[data-oc-header]');
    var mega = $('[data-oc-mega]');
    if (header && mega) {
      $$('[data-oc-mega-open]').forEach(function (el) {
        el.addEventListener('mouseenter', function () { mega.classList.add('is-open'); });
      });
      header.addEventListener('mouseleave', function () { mega.classList.remove('is-open'); });
    }

    var mnav = $('[data-oc-mobile-nav]');
    var burger = $('[data-oc-burger]');
    if (!mnav || !burger) return;

    function open() { mnav.classList.add('is-open'); }
    function close() { mnav.classList.remove('is-open'); }

    burger.addEventListener('click', open);
    $$('[data-oc-mobile-close]', mnav).forEach(function (b) {
      b.addEventListener('click', close);
    });
    // Escape closes the drawer, and following a link inside it should not leave
    // the panel open behind the next page in browsers that restore from cache.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    $$('a', mnav).forEach(function (a) { a.addEventListener('click', close); });
    window.addEventListener('pageshow', close);
  }

  /* ---------- cart ---------- */
  function rebuyCart() {
    return (window.Rebuy && window.Rebuy.SmartCart &&
            typeof window.Rebuy.SmartCart.show === 'function')
      ? window.Rebuy.SmartCart
      : null;
  }

  function openCart() {
    var rc = rebuyCart();
    if (rc) {
      try {
        var p = rc.setCartAsync ? rc.setCartAsync() : null;
        if (p && typeof p.then === 'function') {
          p.then(function () { rc.show(); }).catch(function () { rc.show(); });
        } else {
          rc.show();
        }
        return true;
      } catch (e) { /* fall through to the cart page */ }
    }
    return false;
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function refreshCount() {
    var badges = $$('[data-oc-cart-count]');
    if (!badges.length) return;
    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        badges.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { /* leave the server-rendered count in place */ });
  }

  function initCart() {
    $$('[data-oc-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // These layouts have no fallback drawer markup, so if Rebuy has not
        // loaded, send the customer to the cart page rather than doing nothing.
        if (!openCart()) window.location.href = cartUrl();
        refreshCount();
      });
    });

    refreshCount();

    // Rebuy and the theme both mutate the cart without a page load. Listen
    // broadly rather than guessing which event this build emits.
    ['cart:updated', 'cart:change', 'rebuy:cart.change', 'rebuy:cart:updated', 'rebuy:smartcart.show']
      .forEach(function (evt) {
        document.addEventListener(evt, refreshCount);
      });
    window.addEventListener('pageshow', refreshCount);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshCount();
    });
  }

  function boot() {
    initHeader();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
